import dynamic from "next/dynamic";

export const DynamicContent023 = dynamic(() => import("./Content023"), {
  suspense: true,
});
